import pick from './pick';
export default function drop(obj, ...keys) {
  let keep = Object.keys(obj).filter(key => !keys.includes(key));
  return pick(obj, ...keep);
}
